// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oVnD","buttons":"styles_buttons__2B06-"};